import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/card-payments", label: "Card Payments", testid: "nav-card-payments-link" },
  { to: "/pos-systems", label: "POS Systems", testid: "nav-pos-systems-link" },
  { to: "/website-design", label: "Web Design", testid: "nav-website-design-link" },
  { to: "/app-design", label: "App Design", testid: "nav-app-design-link" },
  { to: "/faq", label: "FAQ", testid: "nav-faq-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-100"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <img
            src="/brand/fenco-logo.png"
            alt="Fenco Digital"
            className="h-12 md:h-14 w-auto"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-5 lg:gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `nav-link text-sm font-semibold tracking-tight ${
                  isActive ? "text-[#FF5A1F] active" : "text-gray-700 hover:text-gray-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/get-started"
            data-testid="nav-cta-quote"
            className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-semibold text-white bg-[#FF5A1F] hover:bg-[#E04B15] rounded-full transition-all duration-200 shadow-lg shadow-orange-500/20 hover:-translate-y-0.5"
          >
            Get a Quote
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-gray-700"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-gray-100 bg-white" data-testid="nav-mobile-menu">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testid}`}
                className={({ isActive }) =>
                  `text-base font-semibold ${isActive ? "text-[#FF5A1F]" : "text-gray-800"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/get-started"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-semibold text-white bg-[#FF5A1F] rounded-full"
              data-testid="mobile-nav-cta-quote"
            >
              Get a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
